import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  TextField,
  Button,
  Typography,
  Grid,
  TextareaAutosize,
  DialogActions 
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import TextBoxWithCheckbox from './TextBoxWithCheckbox';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { styled } from '@mui/material/styles';
import Post from './Post';
import { decrypt, encrypt } from '../../../Security';
import axios from 'axios'
import { useEffect } from 'react';



const AddAPostPopup = ({ setPosts,posts,handleOpen,handleClose }) => {
  const [title, setTitle] = useState('');
  const [detail, setDetail] = useState('');
  const [checkpoints, setCheckpoints] = useState([]);
  const [addedData,setAddedData] = useState([])
   const [selectedImage, setSelectedImage] = useState(null);
    const [selectedVideo, setSelectedVideo] = useState(null);
    const [selectedAudio, setSelectedAudio] = useState(null);

  const preClose=async()=>{
    await deleteAll()
    handleClose()

  }


  const createFeed = async () => {
    try {
       
      console.log('to:  '+process.env.REACT_APP_PUBLIC_SERVER_URI + '/api/v1/repFeeds/')
      const repId=window?.location?.href?.split('/').pop()
      console.log({
        repId: repId,
        ...addedData
      })
      const response = await fetch(process.env.REACT_APP_PUBLIC_SERVER_URI + '/api/v1/repFeeds/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json' // Specify Content-Type header
        },
        credentials: 'include',
        body: encrypt({
          repId: repId,
          ...addedData
        })
        
  
      });
  
      const data = decrypt(await response.json()); // Parse response as JSON
  
      if (data.feed) {
        
          setPosts((agd)=>[data.feed,...agd])
          handleClose() 
          alert('Feed Created Successfully!')
        }
        
      
      else {
        alert('Error while creating feed. '+data.msg)
      }
  
  
    } catch (error) {
      // Handle any errors
      console.error('Error:', error);
    }
  }

  const deleteAll=async()=>{
    console.log('deleting all sim',addedData)
    if (addedData)
    {
      const {imagePath,videoPath,audioPath}=addedData
      handleDelete(imagePath)
      handleDelete(videoPath)
      handleDelete(audioPath)
    }
  }

  const handleDelete=async(url)=>{
    try {
        const response = await axios.delete(
          `${process.env.REACT_APP_PUBLIC_SERVER_URI}/api/v1/media/delete-media`,
          {
            params: {
              url: url
            },
            headers: {
              // 'Content-Type': 'multipart/form-data' -> Let the browser handle this header
            },
            withCredentials: true,
          }
        );
  
       
       
      } catch (error) {
        console.error('Error deleting media:', error);
      }
}
  

 



  const addPosts=async()=>{
  
    if(addedData ){
      console.log("CREATING POST!!")
        await createFeed()
       
    }
  }

  const removeCheckpoint = (checkpoint, e) => {
    const newCheckpoints = checkpoints.filter((cp) => cp !== checkpoint);
    setCheckpoints(newCheckpoints);
  };

  return (
    <>  
        <DialogTitle>
          <IconButton
            onClick={preClose}
            style={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: 'grey',
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ pt: 2 }}>
        <Post
                                       
              posts={posts}
              setPosts={setPosts}
              adding={true}
              setAddedData={setAddedData}
              handleDelete={handleDelete}
          />
        </DialogContent>
        <DialogActions>
          <Button 
            sx={{ backgroundColor: 'white',width:'150px',textTransform:'none',color:'black' }}
            onClick={preClose}
            variant="outlined"
          >
            Cancel
          </Button>
          <Button 
            type="button"
            variant="contained"
            color="primary"
            onClick={addPosts}
            sx={{width:'150px',textTransform:'none' }}
          >
            Add Post
          </Button>
        </DialogActions>
     
    </>
  );
};

export default AddAPostPopup;
